import React from 'react';

import Carousel from '@hpstellar/core/visId/Carousel';
import ImageWithPlaceholder from '@hpstellar/core/ImageWithPlaceholder';


import './product-mobile-images.less';

export default ({ images }) => {
    const imageWithPlaceholders = Array.isArray(images) && images.reduce((allImages, img, idx) => {
        const { src, alt } = img || {};
        if(src){
            allImages.push(
                <ImageWithPlaceholder key={idx} className='vis-id-product-mobile-image' src={src} alt={alt} />
            )
        }

        return allImages;
    }, [])
    return imageWithPlaceholders.length > 0 ? (
        <Carousel
            className='vis-id-product-mobile-images'
            arrows={false}
            arrowKeyNavigation={false}
            dots={false}
            slidesToShow={1}
            slidesToScroll={1}
        >
            {
                imageWithPlaceholders
            }
        </Carousel>
    ) : <div className='vis-id-product-mobile-empty-image' />
}